<div class="confirm-modal ig-modal set-page-tag-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div>
        <div class="title">Set Page URL and City Code</div>

        <mat-dialog-content class="dialog-content">
            <div [formGroup]="form">
                <div class="group">
                    <ig-field label="Page URL *" [(ngModel)]="page.url" [isRequired]="true" icon="link"
                        [formControl]="form.get('url')">
                    </ig-field>
                </div>
                <div class="group">
                    <ig-field label="City code *" [(ngModel)]="page.tag" [isRequired]="true" icon="code"
                        [formControl]="form.get('tag')">
                    </ig-field>
                </div>

            </div>
        </mat-dialog-content>
    </div>

    <div class="action-row flex">
        <ig-button class="m-l-3" color="cancel" (trigger)="close()">
            Cancel
        </ig-button>
        <ig-button size="md" [isAsync]="true" (trigger)="save()">
            Save
        </ig-button>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/event.spider/set.eventpage.tag.modal/set.eventpage.tag.modal.component.html